import styled from "styled-components";
import { Button } from "../../atoms";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  flex-direction: column;
  width: 100%;
`;

export const DetailsTable = styled.table`
  width: 100%;
  margin-bottom: 1rem;
  border-collapse: collapse;
  font-size: 12px;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const TableHeader = styled.thead`
  background-color: #f8f9fa;
`;

export const TableBody = styled.tbody`
  tr:nth-child(even) {
    background-color: #ffffff;
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #dee2e6;
`;

export const TableColumn = styled.th`
  padding: 8px 4px;
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

export const TableCell = styled.td`
  padding: 8px 4px;
  /*  white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
`;

export const ActionCell = styled(TableCell)`
  white-space: nowrap;
  width: 15%;

  div {
    display: flex;
    gap: 4px;

    a,
    button {
      max-width: 40px;
    }
  }
`;

export const ActionButton = styled(Button)`
  padding: 4px 8px;
  font-size: 10px;
  margin: 0 2px;
`;

export const EmptyTableWrapper = styled.div`
  margin: 2rem 0.9rem 0rem 0rem;
`;

export const EmptyTable = styled.p`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: ${({ theme }) => theme.colors.secondary};
  background-color: ${({ theme }) => theme.colors.background_800 + "22"};
  padding: 12px 16px;
  border-radius: 8px;

  i {
    color: ${({ theme }) => theme.colors.danger};
  }
`;
